<template>
  <v-edit-dialog :return-value.sync="inputValue" ref="dialogRef">
    <div :id="inputId">
      <span v-if="inputValue">{{ inputValue }}</span>
      <span v-else class="text--disabled">&mdash;</span>
    </div>
    <template v-slot:input>
      <div class="py-4">
        <v-text-field
          outlined
          dense
          hide-details
          v-model="inputValue"
          :id="`text-field-${inputId}`"
          @blur="triggerEnterKeyPressEvent($event.target.id)"
          @keydown.tab.exact.prevent="handleTabPress"
          @keydown.shift.tab.prevent="handleShiftTabPress"
          single-line
        ></v-text-field>
      </div>
    </template>
  </v-edit-dialog>
</template>

<script lang="ts">
  import { mixins } from '@/mixin/mixins';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'TextInputDialog',
    mixins: [mixins],
    props: {
      value: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
      nextElementId: {
        type: String,
        default: '',
      },
      prevElementId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        inputValue: this.value,
        inputId: this.id,
      };
    },
    watch: {
      inputValue(newVal) {
        this.$emit('input', newVal);
      },
    },
    methods: {
      onBlur(e: string) {
        this.$emit('onBlur', e);
      },
      handleTabPress() {
        this.triggerEnterKeyPressEvent(`text-field-${this.inputId}`);
        this.clickElementbyId(this.nextElementId);
      },
      handleShiftTabPress() {
        this.triggerEnterKeyPressEvent(`text-field-${this.inputId}`);
        this.clickElementbyId(this.prevElementId);
      },
    },
  });
</script>
